module.exports = __webpack_public_path__ + "img/yqgz.d1f076bb.jpg";